module.exports = __webpack_public_path__ + "static/Pit Pay White-0bf0494e0c763d255c5667f682696218.svg";